module.exports = __webpack_public_path__ + "static/media/sorocred.5c1c6239.svg";